import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FilterOperatorsTranslationFrPipe} from './filter-operators-translation-fr.pipe';



@NgModule({
  declarations: [FilterOperatorsTranslationFrPipe],
  imports: [
    CommonModule
  ],
  exports: [FilterOperatorsTranslationFrPipe]
})
export class SyncfusionTranslationModule { }
